import Component from '@bythepixel/component-loader';

export default class CollapsibleText extends Component {
  static selector = '[data-comp-collapsible-text]';
  static loaderPriority = 'in-view'

  #collapsed = false

  constructor(container) {
    super(container);
    this.collapsibleTextContent = this.$container.querySelector('[data-comp-collapsible-text-content]');
    this.collapsibleTextContentHeight = this.$container.querySelector('[data-comp-collapsible-text-content-height]');
    this.triggerButton = this.$container.querySelector('[data-comp-collapsible-text-toggle]');
    this.triggerButtonText = this.triggerButton.querySelector('.btn__text') ?? this.triggerButton;

    this.init();
  }

  init() {
    if (this.collapsibleTextContent.offsetHeight > parseInt(getComputedStyle(this.collapsibleTextContentHeight).maxHeight, 10)) {
      this.collapseContent();
      this.#collapsed = true;
      this.showTriggerButton();
      this.initEventListeners();
    } else {
      this.hideTriggerButton();
    }
  }

  collapseContent() {
    this.collapsibleTextContent.classList.add('collapsed');
  }

  hideTriggerButton() {
    if (this.triggerButton) this.triggerButton.style.display = 'none';
  }

  showTriggerButton() {
    if (this.triggerButton) this.triggerButton.style.display = 'block';
  }

  initEventListeners() {
    this.triggerButton.addEventListener('click', () => {
      this.expandOrCollapse();
    });
  }

  expandOrCollapse() {
    if (!this.#collapsed) {
      this.collapseTextContainer();
    } else if (this.#collapsed) {
      this.expandTextContainer();
    }
  }

  expandTextContainer() {
    this.#collapsed = false;
    this.collapsibleTextContent.classList.add('max-lines__expanded');

    if (this.triggerButton) this.triggerButtonText.innerHTML = 'Read Less';
  }

  collapseTextContainer() {
    this.#collapsed = true;
    this.collapsibleTextContent.classList.remove('max-lines__expanded');

    if (this.triggerButton) this.triggerButtonText.innerHTML = 'Read More';
  }
}
